const updateSlug = (slug: string) => {
  if (slug.startsWith('/dashboard')) {
    return slug.replace('/dashboard', '');
  }
  return slug;
};

export default updateSlug;
